<template>
  <div>
    <v-dialog
        v-model="largeChartVisible"
        max-width="1000"
        eager
      >
        <v-card>
          <v-card-title class="justify-center">
            <span class="title font-weight-heavy">{{title}}</span>
          </v-card-title>
          <div >
            <div class="text-center">
              <v-btn-toggle   style="border:1px #ccc solid; margin-right:20px;" v-model="largeChartTimeSplit">
                <v-btn  style="border-left:1px #ccc solid;" value="month">
                  Kuukausittain
                </v-btn>
                <v-btn  style="border-left:1px #ccc solid;" value="week">
                  Viikottain
                </v-btn>
              </v-btn-toggle>
            </div>
            <div  style="min-height:400px">
              <apexchart v-if="series[largeChartTimeSplit]" :type="type" :options="{...options[largeChartTimeSplit],colors:['#f26539', '#000', '#9C27B0']}" :series="series[largeChartTimeSplit]"></apexchart>
            </div>
            <!-- <apexchart v-if="largeChartTimeSplit=== 'month'" type="bar" :options="largeChartOptions" :series="largeChartData"></apexchart> -->
          </div>
        </v-card>
      </v-dialog>
      <div class="performance-bar-chart-header">{{title}}
        <v-icon
          small 
          left
          @click="largeChartVisible = true"
          style="padding-left:20px"
        >far fa-eye</v-icon>
      </div>
      <apexchart v-if="series[getSmallChartSplit] !== ''" style="width:100%" :type="type" :options="{...options[getSmallChartSplit],colors:['#f26539', '#000', '#9C27B0']}" :series="series[getSmallChartSplit]"></apexchart>
  </div>
</template>
<script>
export default {
    props: ['options', 'series', 'type', 'title','smallChartSplit'],
    data: () => ({
      showChart:false,
      largeChartVisible:false,
      largeChartTimeSplit:"month"
    }),
    watch: {
      series: {
        handler(val){
          //console.log("GENERATING PRODUCTS DATA")
          this.showChart = false
          this.showChart = true
        },
        deep: true
      },
    },
    mounted() {
      //this.showChart = true
    },  
    computed: {
      getSmallChartSplit(){
        var split= 'month'
        if(this.smallChartSplit !== undefined) split = this.smallChartSplit
        return split
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {},
    methods: {
      close () {
        this.dialog = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      inlineCancel () {
      },
      inlineOpen () {
      },
      inlineClose () {
        //console.log('Dialog closed')
      }
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/ReportChart.vue